import { Injectable } from "@angular/core";

interface SpecialityInterface {
    code: string,
    libelle: string,
}

export const MedecinSpecialities: Array<SpecialityInterface> = [
    {
        code: "SM01",
        libelle: "Anatomie et cytologie pathologiques (SM)"
    },
    {
        code: "SM02",
        libelle: "Anesthésie-réanimation (SM)"
    },
    {
        code: "SM03",
        libelle: "Biologie médicale (SM)"
    },
    {
        code: "SM04",
        libelle: "Cardiologie et maladies vasculaires (SM)"
    },
    {
        code: "SM05",
        libelle: "Chirurgie générale (SM)"
    },
    {
        code: "SM06",
        libelle: "Chirurgie maxillo-faciale (SM)"
    },
    {
        code: "SM07",
        libelle: "Chirurgie maxillo-faciale et stomatologie (SM)"
    },
    {
        code: "SM08",
        libelle: "Chirurgie orthopédique et traumatologie (SM)"
    },
    {
        code: "SM09",
        libelle: "Chirurgie infantile (SM)"
    },
    {
        code: "SM10",
        libelle: "Chirurgie plastique reconstructrice et esthétique (SM)"
    },
    {
        code: "SM11",
        libelle: "Chirurgie thoracique et cardio-vasculaire (SM)"
    },
    {
        code: "SM12",
        libelle: "Chirurgie urologique (SM)"
    },
    {
        code: "SM13",
        libelle: "Chirurgie vasculaire (SM)"
    },
    {
        code: "SM14",
        libelle: "Chirurgie viscérale et digestive (SM)"
    },
    {
        code: "SM15",
        libelle: "Dermatologie et vénéréologie (SM)"
    },
    {
        code: "SM16",
        libelle: "Endocrinologie et métabolisme (SM)"
    },
    {
        code: "SM17",
        libelle: "Génétique médicale (SM)"
    },
    {
        code: "SM18",
        libelle: "Gériatrie (SM)"
    },
    {
        code: "SM19",
        libelle: "Gynécologie médicale (SM)"
    },
    {
        code: "SM20",
        libelle: "Gynécologie-obstétrique (SM)"
    },
    {
        code: "SM21",
        libelle: "Hématologie (SM)"
    },
    {
        code: "SM22",
        libelle: "Hématologie option Maladie du sang (SM)"
    },
    {
        code: "SM23",
        libelle: "Hématologie option Onco-hématologie (SM)"
    },
    {
        code: "SM24",
        libelle: "Gastro-entérologie et hépatologie (SM)"
    },
    {
        code: "SM25",
        libelle: "Médecine du travail (SM)"
    },
    {
        code: "SM26",
        libelle: "Qualifié en médecine générale (SM)"
    },
    {
        code: "SM27",
        libelle: "Médecine interne (SM)"
    },
    {
        code: "SM28",
        libelle: "Médecine nucléaire (SM)"
    },
    {
        code: "SM29",
        libelle: "Médecine physique et réadaptation (SM)"
    },
    {
        code: "SM30",
        libelle: "Néphrologie (SM)"
    },
    {
        code: "SM31",
        libelle: "Neuro-chirurgie (SM)"
    },
    {
        code: "SM32",
        libelle: "Neurologie (SM)"
    },
    {
        code: "SM33",
        libelle: "Neuro-psychiatrie (SM)"
    },
    {
        code: "SM34",
        libelle: "ORL et chirurgie cervico-faciale (SM)"
    },
    {
        code: "SM35",
        libelle: "Oncologie option onco-hématologie (SM)"
    },
    {
        code: "SM36",
        libelle: "Oncologie option médicale (SM)"
    },
    {
        code: "SM37",
        libelle: "Oncologie option radiothérapie (SM)"
    },
    {
        code: "SM38",
        libelle: "Ophtalmologie (SM)"
    },
    {
        code: "SM39",
        libelle: "Oto-rhino-laryngologie (SM)"
    },
    {
        code: "SM40",
        libelle: "Pédiatrie (SM)"
    },
    {
        code: "SM41",
        libelle: "Pneumologie (SM)"
    },
    {
        code: "SM42",
        libelle: "Psychiatrie (SM)"
    },
    {
        code: "SM43",
        libelle: "Psychiatrie option enfant et adolescent (SM)"
    },
    {
        code: "SM44",
        libelle: "Radiodiagnostic (SM)"
    },
    {
        code: "SM45",
        libelle: "Radiothérapie (SM)"
    },
    {
        code: "SM46",
        libelle: "Médecine intensive-réanimation (SM)"
    },
    {
        code: "SM47",
        libelle: "Recherche médicale (SM)"
    },
    {
        code: "SM48",
        libelle: "Rhumatologie (SM)"
    },
    {
        code: "SM49",
        libelle: "Santé publique et médecine sociale (SM)"
    },
    {
        code: "SM50",
        libelle: "Stomatologie (SM)"
    },
    {
        code: "SM51",
        libelle: "Gynéco-obstétrique et Gynéco médicale option Gynéco-obst. (SM)"
    },
    {
        code: "SM52",
        libelle: "Gynéco-obstétrique et Gynéco médicale option Gynéco-médicale (SM)"
    },
    {
        code: "SM53",
        libelle: "Spécialiste en médecine générale (SM)"
    },
    {
        code: "SM54",
        libelle: "Médecine générale (SM)"
    },
    {
        code: "SM55",
        libelle: "Radiodiagnostic et radiothérapie (SM)SM56 Chirurgie orale (SM)"
    },
    {
        code: "SM57",
        libelle: "Allergologie (SM)"
    },
    {
        code: "SM58",
        libelle: "Maladies infectieuses et tropicales (SM)"
    },
    {
        code: "SM59",
        libelle: "Médecine d'urgence (SM)"
    },
    {
        code: "SM60",
        libelle: "Médecine légale et expertises médicales (SM)"
    },
    {
        code: "SM61",
        libelle: "Médecine vasculaire (SM)"
    },
    {
        code: "SM62",
        libelle: "Endocrinologie, diabétologie, nutrition (SM)"
    },
    {
        code: "SM63",
        libelle: "Biologie médicale option biologie générale (SM)"
    },
    {
        code: "SM64",
        libelle: "Biologie médicale option médecine moléculaire, génétique et pharmacologie (SM)"
    },
    {
        code: "SM65",
        libelle: "Biologie médicale option hématologie et immunologie (SM)"
    },
    {
        code: "SM66",
        libelle: "Biologie médicale option agents infectieux (SM)"
    },
    {
        code: "SM67",
        libelle: "Biologie médicale option biologie de la reproduction (SM)"
    },
    {
        code: "SM68",
        libelle: "Chirurgie maxillo-faciale (réforme 2017) (SM)"
    },
    {
        code: "SM69",
        libelle: "Chirurgie pédiatrique option chirurgie viscérale pédiatrique (SM)"
    },
    {
        code: "SM70",
        libelle: "Chirurgie pédiatrique option orthopédie pédiatrique (SM)"
    },
    {
        code: "SM71",
        libelle: "Hématologie (réforme 2017) (SM)"
    },
    {
        code: "SM72",
        libelle: "Médecine interne et immunologie clinique (SM)"
    },
    {
        code: "SCH01",
        libelle: "Anatomie et cytologie pathologiques (SCH)"
    },
    {
        code: "SCH02",
        libelle: "Anesthésie-réanimation (SCH)"
    },
    {
        code: "SCH03",
        libelle: "Bactériologie-virologie, hygiène hospitalière (SCH)"
    },
    {
        code: "SCH04",
        libelle: "Biochimie (SCH)"
    },
    {
        code: "SCH05",
        libelle: "Biologie cellulaire, histologie, biologie du développement et de la reproduction (SCH)"
    },
    {
        code: "SCH06",
        libelle: "Biologie médicale (SCH)"
    },
    {
        code: "SCH07",
        libelle: "Biophysique (SCH)"
    },
    {
        code: "SCH08",
        libelle: "Oncologie médicale (SCH)"
    },
    {
        code: "SCH09",
        libelle: "Cardiologie et maladies vasculaires (SCH)"
    },
    {
        code: "SCH10",
        libelle: "Chirurgie générale (SCH)"
    },
    {
        code: "SCH11",
        libelle: "Chirurgie viscérale et digestive (SCH)"
    },
    {
        code: "SCH12",
        libelle: "Chirurgie infantile (SCH)"
    },
    {
        code: "SCH13",
        libelle: "Chirurgie maxillo-faciale (SCH)"
    },
    {
        code: "SCH14",
        libelle: "Chirurgie orthopédique et traumatologique (SCH)"
    },
    {
        code: "SCH15",
        libelle: "Chirurgie plastique reconstructrice et esthétique (SCH)"
    },
    {
        code: "SCH16",
        libelle: "Chirurgie thoracique et cardio-vasculaire (SCH)"
    },
    {
        code: "SCH17",
        libelle: "Chirurgie urologique (SCH)"
    },
    {
        code: "SCH18",
        libelle: "Chirurgie vasculaire (SCH)"
    },
    {
        code: "SCH19",
        libelle: "Dermatologie et vénéréologie (SCH)"
    },
    {
        code: "SCH20",
        libelle: "Endocrinologie et métabolisme (SCH)"
    },
    {
        code: "SCH21",
        libelle: "Santé publique (SCH)"
    },
    {
        code: "SCH22",
        libelle: "Explorations fonctionnelles (SCH)"
    },
    {
        code: "SCH23",
        libelle: "Gastro-entérologie et hépatologie (SCH)"
    },
    {
        code: "SCH24",
        libelle: "Génétique (SCH)"
    },
    {
        code: "SCH25",
        libelle: "Génétique médicale (SCH)"
    },
    {
        code: "SCH26",
        libelle: "Gynécologie et obstétrique (SCH)"
    },
    {
        code: "SCH27",
        libelle: "Hématologie biologique (SCH)"
    },
    {
        code: "SCH28",
        libelle: "Hématologie clinique (SCH)"
    },
    {
        code: "SCH29",
        libelle: "Hémobiologie-transfusion (SCH)SCH30 Hygiène hospitalière (SCH)"
    },
    {
        code: "SCH31",
        libelle: "Immunologie biologique (SCH)"
    },
    {
        code: "SCH32",
        libelle: "Immunologie clinique (SCH)"
    },
    {
        code: "SCH33",
        libelle: "Maladies infectieuses, maladies tropicales (SCH)"
    },
    {
        code: "SCH34",
        libelle: "Médecine de la reproduction et gynécologie médicale (SCH)"
    },
    {
        code: "SCH35",
        libelle: "Médecine du travail (SCH)"
    },
    {
        code: "SCH36",
        libelle: "Médecine d'urgence (SCH)"
    },
    {
        code: "SCH37",
        libelle: "Médecine générale (SCH)"
    },
    {
        code: "SCH38",
        libelle: "Gériatrie (SCH)"
    },
    {
        code: "SCH39",
        libelle: "Médecine interne (SCH)"
    },
    {
        code: "SCH40",
        libelle: "Médecine légale (SCH)"
    },
    {
        code: "SCH41",
        libelle: "Médecine nucléaire (SCH)"
    },
    {
        code: "SCH42",
        libelle: "Médecine physique et de réadaptation (SCH)"
    },
    {
        code: "SCH43",
        libelle: "Néphrologie (SCH)"
    },
    {
        code: "SCH44",
        libelle: "Neurochirurgie (SCH)"
    },
    {
        code: "SCH45",
        libelle: "Neurologie (SCH)"
    },
    {
        code: "SCH46",
        libelle: "Odontologie polyvalente (SCH)"
    },
    {
        code: "SCH47",
        libelle: "Ophtalmologie (SCH)"
    },
    {
        code: "SCH48",
        libelle: "Oto-rhino-laryngologie (SCH)"
    },
    {
        code: "SCH49",
        libelle: "Parasitologie (SCH)"
    },
    {
        code: "SCH50",
        libelle: "Pédiatrie (SCH)"
    },
    {
        code: "SCH51",
        libelle: "Pharmacie polyvalente et pharmacie hospitalière (SCH)"
    },
    {
        code: "SCH52",
        libelle: "Pharmacologie clinique et toxicologie (SCH)"
    },
    {
        code: "SCH53",
        libelle: "Pneumologie (SCH)"
    },
    {
        code: "SCH54",
        libelle: "Psychiatrie polyvalente (SCH)"
    },
    {
        code: "SCH55",
        libelle: "Radiologie (SCH)"
    },
    {
        code: "SCH56",
        libelle: "Oncologie radiothérapique (SCH)"
    },
    {
        code: "SCH57",
        libelle: "Réanimation médicale (SCH)"
    },
    {
        code: "SCH58",
        libelle: "Rhumatologie (SCH)"
    },
    {
        code: "SCH59",
        libelle: "Stomatologie (SCH)"
    },
    {
        code: "SCH60",
        libelle: "Toxicologie et pharmacologie (SCH)"
    },
    {
        code: "PAC00",
        libelle: "Qualifié Praticien Adjoint Contractuel (PAC)"
    },
    {
        code: "C01",
        libelle: "Anatomie et cytologie pathologiques humaines (C)"
    },
    {
        code: "C03",
        libelle: "Anesthésie-réanimation (C)"
    },
    {
        code: "C05",
        libelle: "Médecine appliquée aux sports (C)"
    },
    {
        code: "C07",
        libelle: "Cardiologie (C)"
    },
    {
        code: "C09",
        libelle: "Chirurgie plastique reconstructrice et esthétique (C)"
    },
    {
        code: "C10",
        libelle: "Chirurgie maxillo-faciale (C)"
    },
    {
        code: "C11",
        libelle: "Chirurgie thoracique (C)"
    },
    {
        code: "C12",
        libelle: "Chirurgie orthopédique (C)"
    },
    {
        code: "C13",
        libelle: "Urologie (C)"
    },
    {
        code: "C15",
        libelle: "Dermato-vénéréologie (C)"
    },
    {
        code: "C20",
        libelle: "Hémobiologie (C)"
    },
    {
        code: "C23",
        libelle: "Gynécologie médicale et obstétrique (C)"
    },
    {
        code: "C25",
        libelle: "Gynécologie médicale (C)"
    },
    {
        code: "C27",
        libelle: "Obstétrique (C)"
    },
    {
        code: "C29",
        libelle: "Maladies de l'appareil digestif (C)C30 Néphrologie (C)"
    },
    {
        code: "C31",
        libelle: "Médecine exotique (C)"
    },
    {
        code: "C33",
        libelle: "Allergologie (C)"
    },
    {
        code: "C34",
        libelle: "Angéiologie (C)"
    },
    {
        code: "C35",
        libelle: "Cancérologie (C)"
    },
    {
        code: "C36",
        libelle: "Diabétologie-nutrition (C)"
    },
    {
        code: "C37",
        libelle: "Endocrinologie (C)"
    },
    {
        code: "C38",
        libelle: "Maladies du sang (C)"
    },
    {
        code: "C39",
        libelle: "Réanimation (C)"
    },
    {
        code: "C40",
        libelle: "Médecine légale (C)"
    },
    {
        code: "C41",
        libelle: "Médecine du travail (C)"
    },
    {
        code: "C43",
        libelle: "Neurologie (C)"
    },
    {
        code: "C45",
        libelle: "Neuro-chirurgie (C)"
    },
    {
        code: "C47",
        libelle: "Neuro-psychiatrie (C)"
    },
    {
        code: "C51",
        libelle: "Pédiatrie (C)"
    },
    {
        code: "C52",
        libelle: "Phoniatrie (C)"
    },
    {
        code: "C54",
        libelle: "Pneumologie (C)"
    },
    {
        code: "C57",
        libelle: "Psychiatrie (C)"
    },
    {
        code: "C58",
        libelle: "Psychiatrie option enfant et adolescent (C)"
    },
    {
        code: "C60",
        libelle: "Médecine physique et réadaptation (C)"
    },
    {
        code: "C62",
        libelle: "Rhumatologie (C)"
    },
    {
        code: "C68",
        libelle: "Chirurgie pédiatrique (C)"
    },
    {
        code: "C69",
        libelle: "Médecine nucléaire (C)"
    },
    {
        code: "C71",
        libelle: "Médecine thermale (C)"
    },
    {
        code: "C72",
        libelle: "Génétique médicale (C)"
    },
    {
        code: "C75",
        libelle: "Endocrinologie maladies métaboliques (C)"
    },
    {
        code: "C76",
        libelle: "Orthopédie dento-maxillo-faciale (C)"
    },
    {
        code: "C83",
        libelle: "Chirurgie de la face et du cou (C)"
    },
    {
        code: "CEX22",
        libelle: "Gynécologie médicale et obstétrique (CEX)"
    },
    {
        code: "CEX24",
        libelle: "Gynécologie médicale (CEX)"
    },
    {
        code: "CEX26",
        libelle: "Obstétrique (CEX)"
    },
    {
        code: "CEX64",
        libelle: "Urologie (CEX)"
    },
    {
        code: "DSM200",
        libelle: "Addictologie (DNQ)"
    },
    {
        code: "DSM201",
        libelle: "Allergologie et Immunologie clinique (DNQ)"
    },
    {
        code: "DSM202",
        libelle: "Andrologie (DNQ)"
    },
    {
        code: "DSM203",
        libelle: "Biochimie hormonale et métabolique (DNQ)"
    },
    {
        code: "DSM204",
        libelle: "Biologie des agents infectieux (DNQ)"
    },
    {
        code: "DSM205",
        libelle: "Biologie moléculaire (DNQ)"
    },
    {
        code: "DSM206",
        libelle: "Cancérologie (DNQ)"
    },
    {
        code: "DSM207",
        libelle: "Chirurgie de la face et du cou (DNQ)"
    },
    {
        code: "DSM208",
        libelle: "Chirurgie plastique et reconstructrice (DNQ)"
    },
    {
        code: "DSM209",
        libelle: "Chirurgie vasculaire (DNQ)"
    },
    {
        code: "DSM210",
        libelle: "Cytogénétique humaine (DNQ)"
    },
    {
        code: "DSM211",
        libelle: "Dermatopathologie (DNQ)"
    },
    {
        code: "DSM212",
        libelle: "Foetopathologie (DNQ)"
    },
    {
        code: "DSM213",
        libelle: "Gériatrie (DNQ)"
    },
    {
        code: "DSM214",
        libelle: "Hématologie biologique (DNQ)DSM215 Hématologie maladies du sang (DNQ)"
    },
    {
        code: "DSM216",
        libelle: "Hémobiologie-transfusion (DNQ)"
    },
    {
        code: "DSM217",
        libelle: "Immunologie et Immunopathologie (DNQ)"
    },
    {
        code: "DSM218",
        libelle: "Médecine de la reproduction (DNQ)"
    },
    {
        code: "DSM219",
        libelle: "Médecine du sport (DNQ)"
    },
    {
        code: "DSM220",
        libelle: "Médecine d'urgence (DNQ)"
    },
    {
        code: "DSM221",
        libelle: "Médecine légale et Expertises médicales (DNQ)"
    },
    {
        code: "DSM222",
        libelle: "Médecine nucléaire (DNQ)"
    },
    {
        code: "DSM223",
        libelle: "Médecine vasculaire (DNQ)"
    },
    {
        code: "DSM224",
        libelle: "Néonatalogie (DNQ)"
    },
    {
        code: "DSM225",
        libelle: "Neuropathologie (DNQ)"
    },
    {
        code: "DSM226",
        libelle: "Nutrition (DNQ)"
    },
    {
        code: "DSM227",
        libelle: "Orthopédie dento-maxillo-faciale (DNQ)"
    },
    {
        code: "DSM228",
        libelle: "Pathologie infectieuse et tropicale, clinique et biologique (DNQ)"
    },
    {
        code: "DSM229",
        libelle: "Pharmacocinétique et Métabolisme des médicaments (DNQ)"
    },
    {
        code: "DSM230",
        libelle: "Pharmacologie clinique et Evaluation des thérapeutiques (DNQ)"
    },
    {
        code: "DSM231",
        libelle: "Psychiatrie de l'enfant et de l'adolescent (DNQ)"
    },
    {
        code: "DSM232",
        libelle: "Radiopharmacie et radiobiologie (DNQ)"
    },
    {
        code: "DSM233",
        libelle: "Réanimation médicale (DNQ)"
    },
    {
        code: "DSM234",
        libelle: "Toxicologie biologique (DNQ)"
    },
    {
        code: "DSM235",
        libelle: "Médecine de la douleur et Médecine palliative (DNQ)"
    },
    {
        code: "DSM236",
        libelle: "Cancérologie, option Traitements médicaux des cancers (DNQ)"
    },
    {
        code: "DSM237",
        libelle: "Cancérologie, option Chirurgie cancérologique (DNQ)"
    },
    {
        code: "DSM238",
        libelle: "Cancérologie, option Réseaux de cancérologie (DNQ)"
    },
    {
        code: "DSM239",
        libelle: "Cancérologie, option Biologie cancérologie (DNQ)"
    },
    {
        code: "DSM240",
        libelle: "Cancérologie, option Imagerie cancérologie (DNQ)"
    },
    {
        code: "CAPA01",
        libelle: "Addictologie clinique (CAPA)"
    },
    {
        code: "CAPA02",
        libelle: "Aide médicale urgente (CAPA)"
    },
    {
        code: "CAPA03",
        libelle: "Allergologie (CAPA)"
    },
    {
        code: "CAPA04",
        libelle: "Angéiologie (CAPA)"
    },
    {
        code: "CAPA05",
        libelle: "Evaluation et traitement de la douleur (CAPA)"
    },
    {
        code: "CAPA06",
        libelle: "Gérontologie (CAPA)"
    },
    {
        code: "CAPA07",
        libelle: "Hydrologie et climatologie médicales (CAPA)"
    },
    {
        code: "CAPA08",
        libelle: "Médecine aérospatiale (CAPA)"
    },
    {
        code: "CAPA09",
        libelle: "Médecine de catastrophe (CAPA)"
    },
    {
        code: "CAPA10",
        libelle: "Médecine et biologie du sport (CAPA)"
    },
    {
        code: "CAPA11",
        libelle: "Médecine de santé au travail et prévention des risques professionnels (CAPA)"
    },
    {
        code: "CAPA12",
        libelle: "Médecine pénitentiaire (CAPA)"
    },
    {
        code: "CAPA13",
        libelle: "Médecine tropicale (CAPA)"
    },
    {
        code: "CAPA14",
        libelle: "Pratiques médico-judiciaires (CAPA)"
    },
    {
        code: "CAPA15",
        libelle: "Technologie transfusionnelle (CAPA)"
    },
    {
        code: "CAPA16",
        libelle: "Toxicomanies et alcoologies (CAPA)"
    },
];

export const PharmacienSpecialities: Array<SpecialityInterface> = [
    {
        code: "A",
        libelle: "Pharmacien titulaire d'officine",
    },
    {
        code: "B",
        libelle: "Pharmacien d'entreprise - industrie",
    },
    {
        code: "C",
        libelle: "Pharmacien d'entreprise - distribution",
    },
    {
        code: "D",
        libelle: "Pharmacien adjoint, remplaçant ou gérant",
    },
    {
        code: "DA",
        libelle: "Pharmacien adjoint",
    },
    {
        code: "DM",
        libelle: "Pharmacien mutualiste ou minier",
    },
    {
        code: "E",
        libelle: "Pharmacien d'Outre-Mer",
    },
    {
        code: "EA",
        libelle: "Pharmacien titulaire d'officine - OM",
    },
    {
        code: "EB",
        libelle: "Pharmacien d'entreprise - industrie - OM",
    },
    {
        code: "EC",
        libelle: "Pharmacien d'entreprise - distribution - OM",
    },
    {
        code: "ED",
        libelle: "Pharmacien adjoint - OM",
    },
    {
        code: "EG",
        libelle: "Pharmacien biologiste - OM",
    },
    {
        code: "EH",
        libelle: "Pharmacien d'établissement de santé - OM",
    },
    {
        code: "G",
        libelle: "Pharmacien biologiste",
    },
    {
        code: "H",
        libelle: "Pharmacien d'établissement de santé",
    },
    {
        code: "M",
        libelle: "Pharmacien militaire",
    },
];

export const ChirDentisteSpecialities: Array<SpecialityInterface> = [
    {
        code: 'SCD01',
        libelle: 'Orthopédie dento-faciale (SCD)',
    },
    {
        code: 'SCD02',
        libelle: 'Chirurgie orale (SCD)',
    },
    {
        code: 'SCD03',
        libelle: 'Médecine bucco-dentaire (SCD)',
    },
];

@Injectable({
    providedIn: 'root'
})
export class CpxHandleUtilsService {
}
